import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Menu, Image, Divider } from 'semantic-ui-react';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';

import { endSession } from '../modules/session';

import '../stylesheets/navbar.css';
import Logo from '../images/logo.png';

class HeaderBar extends Component {
  signOut = () => {
    const { connectedEndSession } = this.props;
    connectedEndSession();
  }

  go = (path) => {
    const { connectedPush } = this.props;
    connectedPush(path);
  }

  isProtectedPath = () => {
    const { pathname } = this.props;
    return !!pathname.match(/(recognition|account|keys|customize)/gi);
  }

  gatherItems = (side) => {
    const { signedIn } = this.props;
    let items = [this.logoMenuItem()];
    if (signedIn) {
      items = items.concat(this.privateItemsList());
    }
    if (side) {
      // this is probably jank, and we should probably do this in css
      items.push(<Divider hidden active="false" key="6" />);
    }
    items = items.concat(this.publicMenuItems());
    if (!signedIn) {
      items.push(this.signInItem());
    }

    return items;
  }

  logoMenuItem = () => (
    <Menu.Item key="1" onClick={() => { window.location.href = '/'; }} className="re is-margin-right-100">
      <Image src={Logo} alt="remeeting asr" />
    </Menu.Item>
  )

  privateItemsList = () => {
    const { pathname } = this.props;
    return [
      <Menu.Item
        key="2"
        active={(pathname.match('account') && true)}
        content="Account"
        onClick={() => { this.go('/account'); }}
      />,
      <Menu.Item
        key="4"
        active={(pathname.match('recognition') && true)}
        content="Recognitions"
        onClick={() => { this.go('/recognitions'); }}
      />,
      <Menu.Item
        key="5"
        active={(pathname.match('keys') && true)}
        content="Keys"
        onClick={() => { this.go('/keys'); }}
      />,
      <Divider active="false" key="55" />,
      <Menu.Item
        key="3"
        content="Sign Out"
        onClick={() => { this.signOut(); }}
      />,
      <Divider active="false" key="33" />,
    ];
  }

  publicMenuItems = () => {
    const { pathname } = this.props;
    return [
      <Menu.Item
        key="7"
        active={(pathname.match('status') && true)}
        content="System Status"
        onClick={() => { this.go('/status'); }}
      />,
      <Menu.Item
        key="8"
        active={(pathname.match('docs') && true)}
        content="API Docs"
        onClick={() => { this.go('/docs'); }}
      />,
    ];
  }

  signInItem = () => (
    <Menu.Item
      key="9"
      content="Sign In"
      onClick={() => { window.location.href = `/auth/signin?from=${window.location.pathname}`; }}
    />
  );

  render() {
    const side = this.isProtectedPath();

    return (
      <Menu
        vertical={side}
        fixed={side ? 'left' : 'top'}
        inverted
        borderless
        items={this.gatherItems(side)}
        className={side ? 're is-full-height' : 're is-flex-row-justify-end'}
      />
    );
  }
}

HeaderBar.propTypes = {
  connectedEndSession: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  connectedPush: PropTypes.func.isRequired,
  signedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  pathname: state.router.location.pathname,
  signedIn: state.session.signedIn,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  connectedEndSession: endSession,
  connectedPush: push,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderBar);
